import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AllocateRemainingModal = ({ isOpen, onClose, projectNeeds, weights, remainingPercentage, onAllocate }) => {
  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 z-[9998]" 
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
        <div className="bg-white rounded-lg shadow-2xl max-w-md w-full max-h-[80vh] overflow-hidden">
          {/* Header */}
          <div className="bg-gradient-to-r from-yellow-50 to-orange-50 px-6 py-4 border-b-2 border-yellow-400">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="p-2 bg-yellow-100 rounded-lg">
                  <Icon name="Plus" size={20} className="text-yellow-600" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900">Allocate Remaining</h3>
                  <p className="text-sm text-gray-600">
                    Add {remainingPercentage?.toFixed(2)}% to a need
                  </p>
                </div>
              </div>
              <button
                onClick={onClose}
                className="p-2 hover:bg-yellow-100 rounded-lg transition-colors"
              >
                <Icon name="X" size={20} className="text-gray-600" />
              </button>
            </div>
          </div>

          {/* Content */}
          <div className="p-4 max-h-[60vh] overflow-y-auto">
            <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
              <div className="flex items-center space-x-2 text-blue-800">
                <Icon name="Info" size={16} />
                <span className="text-sm font-medium">
                  Select a need to receive the remaining {remainingPercentage?.toFixed(2)}%
                </span>
              </div>
            </div>

            <div className="space-y-2">
              {projectNeeds?.map((need) => (
                <button
                  key={need?.id}
                  onClick={() => onAllocate(need?.id)}
                  className="w-full text-left p-4 border-2 border-gray-200 rounded-lg hover:border-blue-400 hover:bg-blue-50 transition-all group"
                >
                  <div className="flex items-center space-x-3">
                    <div className={`p-2 rounded-lg flex-shrink-0 group-hover:scale-110 transition-transform ${
                      need?.priority === 'High' ? 'bg-red-100 text-red-600' :
                      need?.priority === 'Medium' ? 'bg-yellow-100 text-yellow-600' : 'bg-green-100 text-green-600'
                    }`}>
                      <Icon name={need?.icon} size={18} />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center justify-between mb-1">
                        <h4 className="font-medium text-gray-900">{need?.name}</h4>
                        <span className={`px-2 py-0.5 rounded text-xs font-medium ${
                          need?.priority === 'High' ? 'bg-red-100 text-red-800' :
                          need?.priority === 'Medium' ? 'bg-yellow-100 text-yellow-800' : 'bg-green-100 text-green-800'
                        }`}>
                          {need?.priority}
                        </span>
                      </div>
                      <div className="flex items-center justify-between">
                        <span className="text-xs text-gray-600">{need?.description}</span>
                        <div className="flex items-center space-x-2 ml-2">
                          <span className="text-sm text-gray-500">Current:</span>
                          <span className="text-sm font-semibold text-gray-900">{weights?.[need?.id] || 0}%</span>
                          <Icon name="ArrowRight" size={14} className="text-gray-400" />
                          <span className="text-sm font-bold text-blue-600">
                            {(parseFloat(weights?.[need?.id] || 0) + remainingPercentage)?.toFixed(2)}%
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </button>
              ))}
            </div>
          </div>

          {/* Footer */}
          <div className="px-6 py-4 bg-gray-50 border-t border-gray-200">
            <Button
              onClick={onClose}
              variant="outline"
              size="md"
              className="w-full"
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AllocateRemainingModal;